"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.match");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _moment = _interopRequireDefault(require("moment"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _lang = _interopRequireDefault(require("@/lang"));

var _qrcodejs = _interopRequireDefault(require("qrcodejs2"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var defaultProps = {
  children: "childs",
  label: "title"
};
var _default = {
  name: 'organizationUser:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['statusOption', 'accountTypeOption', 'forceBindGoogleOption', 'storedGoogleStatusOption']), {
    errorInfo: function errorInfo() {
      return {
        emptyUserName: this.$t('SMS.username') + this.$t('SMS.canNotBeEmpty'),
        invalidAccountNameLength: this.$t('message.message72'),
        invalidAccountName: this.$t('message.message74'),
        emptyPassword: this.$t('SMS.password') + this.$t('SMS.canNotBeEmpty'),
        emptyPayPassword: this.$t('SMS.payPassword') + this.$t('SMS.canNotBeEmpty'),
        emptyConfirmPassword: this.$t('SMS.confirmPassword') + this.$t('SMS.canNotBeEmpty'),
        invalidPayPasswordLength: this.$t('message.message73'),
        invalidPasswordLength: this.$t('message.organizationManagementMessage13'),
        invalidPasswordFormat: this.$t('warningMessage.passwordFormatNoUpperMessage'),
        organizationManagementMessage14: this.$t("message.organizationManagementMessage14")
      };
    },
    rules: function rules() {
      var _this2 = this;

      var checkPasswordFormat = function checkPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (_this2.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this2.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      var checkAccountFormat = function checkAccountFormat(rule, value, callback) {
        var length;
        var minlength = 6;
        var maxlength = 20;

        if (_this2.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyUserName));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidAccountNameLength));
        }

        if (/.*[\u4e00-\u9fa5|\！|\，|\。|\（|\）|\《|\》|\“|\”|\？|\：|\；|\【|\】]+.*/.test(value)) {
          return callback(new Error(_this2.errorInfo.invalidAccountName));
        } else {
          return callback();
        }
      };

      var checkPassword = function checkPassword(rule, value, callback) {
        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyConfirmPassword));
        }

        if (_this2.formTemp.userPassword !== value) {
          return callback(new Error(_this2.errorInfo.organizationManagementMessage14));
        }

        return callback();
      };

      var checkPayPasswordFormat = function checkPayPasswordFormat(rule, value, callback) {
        var length;
        var minlength = 8;
        var maxlength = 20;

        if (_this2.dialogType === 'update') {
          return callback();
        }

        if (!value) {
          return callback(new Error(_this2.errorInfo.emptyPayPassword));
        }

        length = value.length;

        if (length < minlength || length > maxlength) {
          return callback(new Error(_this2.errorInfo.invalidPayPasswordLength));
        }

        if (!value.match(/[A-Z]/g)) {
          return callback(new Error(_this2.errorInfo.invalidPasswordFormat));
        }

        return callback();
      };

      return {
        organizationCode: [{
          required: true,
          message: _lang.default.t('SMS.organizationName') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: 'blur'
        }],
        userName: [{
          required: true,
          message: _lang.default.t('SMS.fullName') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: 'blur'
        }],
        userAccount: [{
          required: true,
          validator: checkAccountFormat,
          trigger: 'blur'
        }],
        userPassword: [{
          required: true,
          validator: checkPasswordFormat,
          trigger: 'blur'
        }],
        checkPassword: [{
          required: true,
          validator: checkPassword,
          trigger: 'blur'
        }],
        payPassword: [{
          required: true,
          validator: checkPayPasswordFormat,
          trigger: "blur"
        }],
        accountType: [{
          required: true,
          message: _lang.default.t('SMS.accountType') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: _lang.default.t('SMS.status') + _lang.default.t('SMS.canNotBeEmpty'),
          trigger: 'blur'
        }]
      };
    }
  }),
  data: function data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      formLoading: false,
      time: null,
      dialogType: '',
      dialogFormVisible: false,
      dialogTreeVisible: false,
      dialogQrcodeVisible: false,
      organizationNameOption: null,
      batchUpdatePermissionFlag: false,
      defaultProps: defaultProps,
      permissionTree: [],
      userLimit: [],
      multipleSelection: [],
      currentID: null,
      textMap: {
        update: _lang.default.t('common.update'),
        create: _lang.default.t('common.addNew'),
        recharge: _lang.default.t('common.recharge'),
        invalid: _lang.default.t('common.invalid'),
        cost: _lang.default.t('common.cost')
      },
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        isGoogle: '',
        username: '',
        operation: '',
        method: ''
      },
      formTemp: {
        organizationCode: '',
        userName: '',
        userAccount: '',
        userPassword: '',
        checkPassword: '',
        accountType: '',
        status: ''
      },
      qrcodeTemp: {
        googleQrcode: null,
        agentAccount: null
      },
      toBeUncheck: [],
      toBeCheck: [],
      monitor: false
    };
  },
  created: function created() {
    this.getOrgs();
    this.getList();
  },
  methods: {
    handleCheck: function handleCheck(node, _ref) {
      var _this3 = this;

      var checkedKeys = _ref.checkedKeys;
      var status = checkedKeys.includes(node.data.menuId.toString());

      if (!status && node.childs.length && this.monitor) {
        this.toBeUncheck.push(parseInt(node.data.menuId));
        this.uncheckChilds(node.childs);
        this.$nextTick(function () {
          var _userLimit = (0, _toConsumableArray2.default)(_this3.userLimit);

          _userLimit = _userLimit.filter(function (menu) {
            return !_this3.toBeUncheck.includes(menu);
          });
          _this3.toBeUncheck = [];
          _this3.userLimit = _userLimit;

          _this3.$refs.tree.setCheckedKeys(_this3.userLimit);
        });
      }

      if (status && this.monitor) {
        this.toBeCheck.push(parseInt(node.data.menuId));
        this.checkChilds(node);
        this.checkParents(node);
        this.$nextTick(function () {
          var _userLimit = (0, _toConsumableArray2.default)(_this3.userLimit);

          _this3.toBeCheck.forEach(function (key) {
            if (!_userLimit.includes(key)) {
              _userLimit.push(key);
            }
          });

          _this3.userLimit = _userLimit;
          _this3.toBeCheck = [];

          _this3.$refs.tree.setCheckedKeys(_this3.userLimit);
        });
      }
    },
    uncheckChilds: function uncheckChilds(childs) {
      var _this4 = this;

      childs.forEach(function (child) {
        _this4.toBeUncheck.push(parseInt(child.data.menuId));

        if (child.childs.length) _this4.uncheckChilds(child.childs);
      });
    },
    checkParents: function checkParents(node) {
      if (!node) return;
      this.toBeCheck.push(parseInt(node.parentId));
      var parentNode = this.findNodeById(this.permissionTree, parseInt(node.parentId));
      this.checkParents(parentNode);
    },
    checkChilds: function checkChilds(node) {
      var _this5 = this;

      if (node.childs.length) {
        node.childs.forEach(function (child) {
          _this5.toBeCheck.push(parseInt(child.data.menuId));

          _this5.checkChilds(child);
        });
      }
    },
    findNodeById: function findNodeById(tree, id) {
      var result;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tree[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var node = _step.value;
          if (parseInt(node.data.menuId) === id) return node;

          if (node.childs.length) {
            result = this.findNodeById(node.childs, id);
            if (result) break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return result;
    },
    convertAccountTypeName: function convertAccountTypeName(name) {
      var found = '';
      this.accountTypeOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertStatusOptionName: function convertStatusOptionName(name) {
      var found = '';
      this.statusOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertForceGoogleOptionName: function convertForceGoogleOptionName(name) {
      var found = '';
      this.forceBindGoogleOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertGoogleStatusOptionName: function convertGoogleStatusOptionName(name) {
      var found = '';
      this.storedGoogleStatusOption.forEach(function (status) {
        if (parseInt(status.key) == name) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertOrganizationName: function convertOrganizationName(name) {
      var found = '';

      if (!this.organizationNameOption) {
        return;
      }

      this.organizationNameOption.forEach(function (status) {
        if (status.organizationCode === name) {
          found = status.organizationName;
          return;
        }
      });
      return found;
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined) {
        return "";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    resetFormTemp: function resetFormTemp() {
      var _this6 = this;

      this.formTemp = {
        id: '',
        organizationCode: this.$store.getters.isMerchant ? this.$store.getters.account.userName : '',
        userName: '',
        userAccount: '',
        userPassword: '',
        checkPassword: '',
        accountType: '',
        status: this.$store.getters.isMerchant ? '1' : '',
        isGoogle: "1",
        description: ''
      };
      this.$nextTick(function (_) {
        _this6.$refs["dataForm"].clearValidate();
      });
    },
    resetPermissionTree: function resetPermissionTree() {
      this.permissionTree = [];
    },
    getRowData: function getRowData(row) {
      this.formTemp = {
        id: row.id,
        organizationCode: row.organizationCode,
        userName: row.userName,
        userAccount: row.userAccount,
        userPassword: '',
        checkPassword: '',
        accountType: row.accountType,
        status: row.status,
        isGoogle: row.isGoogle,
        description: row.description
      };
    },
    getList: function getList() {
      var _this7 = this;

      if (!this.hasViewPermission) {
        return;
      }

      this.listLoading = true;

      _httpUtils.default.post("organizationUser", "list", null, this.listQuery).then(function (res) {
        _this7.list = res.data.rows;
        _this7.total = res.data.total;
        setTimeout(function () {
          _this7.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this7.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    getOrgs: function getOrgs() {
      var _this8 = this;

      _httpUtils.default.post("organization", "getOrgs", null, this.listQuery).then(function (res) {
        _this8.organizationNameOption = res.data;
        setTimeout(function () {
          _this8.listLoading = false;
        }, 1 * 1000);
      }).catch(function (err) {
        _this8.$message({
          message: err.message,
          type: 'error'
        });
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCreate: function handleCreate() {
      var _this9 = this;

      this.resetFormTemp();
      this.dialogType = "create";
      this.formTemp.isGoogle = "1";
      this.$nextTick(function (_) {
        _this9.dialogFormVisible = true;
      });
    },
    doCreateData: function doCreateData() {
      var _this10 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this10.formLoading = true;

          _httpUtils.default.post("organizationUser", "add", null, _this10.formTemp).then(function (res) {
            if (res.code === 200) {
              _this10.$notify({
                title: _lang.default.t('message.message6'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this10.resetFormTemp();

                _this10.getList();

                _this10.dialogFormVisible = false;
                _this10.formLoading = false;
              }, 1 * 1000);
            }
          }).catch(function (err) {
            _this10.$notify({
              title: _lang.default.t('SMS.error'),
              message: err.message,
              type: 'warning',
              duration: 2000
            });

            _this10.formLoading = false;
          });
        }
      });
    },
    handleUpdate: function handleUpdate(row) {
      this.resetFormTemp();
      this.getRowData(row);
      this.dialogType = "update";
      this.dialogFormVisible = true;
    },
    handleUpdatePermission: function handleUpdatePermission(row) {
      this.resetPermissionTree();
      this.getPermissionData(row);
      this.dialogType = "permission";
      this.dialogTreeVisible = true;
    },
    handleBatchUpdatePermission: function handleBatchUpdatePermission() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t('warningMessage.selectUserToUpdatePermissionMessage'),
          type: 'error'
        });
      } else {
        this.resetPermissionTree();
        this.getPermissionDataForBatchUpdate();
        this.batchUpdatePermissionFlag = true;
        this.dialogType = "permission";
        this.dialogTreeVisible = true;
      }
    },
    getPermissionData: function getPermissionData(row) {
      var _this11 = this;

      this.currentID = row.id;

      _httpUtils.default.post("organizationUserMenu", "tree", null, {
        organizationUserID: this.currentID
      }).then(function (res) {
        _this11.permissionTree = res.data.menus;
        _this11.userLimit = res.data.organizationUserLimit;

        _this11.$refs.tree.setCheckedKeys(_this11.userLimit);

        _this11.monitor = true;
      }).catch(function (e) {
        _this11.$notify({
          title: _lang.default.t('SMS.alarm'),
          message: e.message,
          type: 'error',
          duration: 2000
        });
      });
    },
    getPermissionDataForBatchUpdate: function getPermissionDataForBatchUpdate() {
      var _this12 = this;

      _httpUtils.default.post("organizationUserMenu", "getAllTree", null, null).then(function (res) {
        // this.permissionTree = this.handleTreeData(res.data.menus);
        _this12.permissionTree = res.data.menus;

        _this12.$refs.tree.setCheckedKeys(_this12.userLimit);

        _this12.monitor = true;
      }).catch(function (err) {
        _this12.$notify({
          title: _lang.default.t('SMS.alarm'),
          message: e.message,
          type: 'error',
          duration: 2000
        });
      });
    },
    doUpdateData: function doUpdateData() {
      var _this13 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          _this13.formLoading = true;

          _httpUtils.default.post("organizationUser", "update", null, _this13.formTemp).then(function (res) {
            if (res.code === 200) {
              _this13.$notify({
                title: _lang.default.t('SMS.success'),
                message: res.data,
                type: 'success',
                duration: 2000
              });

              setTimeout(function () {
                _this13.resetFormTemp();

                _this13.getList();

                _this13.dialogFormVisible = false;
                _this13.formLoading = false;
              }, 1 * 1000);
            }
          }).catch(function (e) {
            _this13.formLoading = false;

            _this13.$notify({
              title: _lang.default.t('SMS.alarm'),
              message: _lang.default.t('message.message42') + ',' + e.message,
              type: 'warning',
              duration: 2000
            });
          });
        }
      });
    },
    handleDelete: function handleDelete(state) {
      var _this14 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === 'delete') {
        message = _lang.default.t('message.message1');
        info = _lang.default.t('SMS.alarm');
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t('permission.confirm'),
        cancelButtonText: _lang.default.t('permission.cancel'),
        type: 'warning'
      }).then(function () {
        _this14.doDeleteData();
      }).catch(function () {
        _this14.$message({
          type: 'info',
          message: _lang.default.t('message.message3')
        });
      });
    },
    doDeleteData: function doDeleteData() {
      var _this15 = this;

      var ids = [];

      for (var data in this.multipleSelection) {
        ids.push(this.multipleSelection[data].id);
      }

      _httpUtils.default.post("organizationUser", "delete", null, ids).then(function (res) {
        if (res.code === 200) {
          _this15.$notify({
            title: _lang.default.t('SMS.success'),
            message: _lang.default.t('message.organizationManagementMessage4'),
            type: 'success',
            duration: 2000
          });

          _this15.listQuery.pageNum = _this15.listQuery.pageNum;
          _this15.listQuery.pageSize = 10;

          _this15.resetFormTemp();

          _this15.getList();
        }
      }).catch(function (e) {
        _this15.$message({
          showClose: true,
          message: _lang.default.t('message.message5') + e.message,
          type: 'warning'
        });
      });
    },
    handleBatchLock: function handleBatchLock(state) {
      var _this16 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === 'batchLock') {
        message = _lang.default.t('message.organizationManagementMessage27');
        info = _lang.default.t('SMS.alarm');
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t('permission.confirm'),
        cancelButtonText: _lang.default.t('permission.cancel'),
        type: 'warning'
      }).then(function () {
        _this16.doBatchLockData();
      }).catch(function () {
        _this16.$message({
          type: 'info',
          message: _lang.default.t('message.organizationManagementMessage31')
        });
      });
    },
    doBatchLockData: function doBatchLockData() {
      var _this17 = this;

      var ids = '';

      for (var data in this.multipleSelection) {
        ids = ids === "" ? this.multipleSelection[data].id.toString() : ids.concat(',' + this.multipleSelection[data].id.toString());
      }

      _httpUtils.default.post("organizationUser", "lock", null, ids).then(function (res) {
        if (res.code === 200) {
          _this17.$notify({
            title: _lang.default.t('SMS.success'),
            message: _lang.default.t('message.organizationManagementMessage28'),
            type: 'success',
            duration: 2000
          });

          _this17.listQuery.pageNum = _this17.listQuery.pageNum;
          _this17.listQuery.pageSize = 10;

          _this17.resetFormTemp();

          _this17.getList();
        }
      }).catch(function (e) {
        _this17.$message({
          showClose: true,
          message: _lang.default.t('message.organizationManagementMessage29') + e.message,
          type: 'warning'
        });
      });
    },
    handleBatchUnlock: function handleBatchUnlock(state) {
      var _this18 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === 'batchUnlock') {
        message = _lang.default.t('message.organizationManagementMessage30');
        info = _lang.default.t('SMS.alarm');
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t('permission.confirm'),
        cancelButtonText: _lang.default.t('permission.cancel'),
        type: 'warning'
      }).then(function () {
        _this18.doBatchUnlockData();
      }).catch(function () {
        _this18.$message({
          type: 'info',
          message: _lang.default.t('message.organizationManagementMessage32')
        });
      });
    },
    doBatchUnlockData: function doBatchUnlockData() {
      var _this19 = this;

      var ids = '';

      for (var data in this.multipleSelection) {
        ids = ids === "" ? this.multipleSelection[data].id.toString() : ids.concat(',' + this.multipleSelection[data].id.toString());
      }

      _httpUtils.default.post("organizationUser", "unlock", null, ids).then(function (res) {
        if (res.code === 200) {
          _this19.$notify({
            title: _lang.default.t('SMS.success'),
            message: _lang.default.t('message.organizationManagementMessage33'),
            type: 'success',
            duration: 2000
          });

          _this19.listQuery.pageNum = _this19.listQuery.pageNum;
          _this19.listQuery.pageSize = 10;

          _this19.resetFormTemp();

          _this19.getList();
        }
      }).catch(function (e) {
        _this19.$message({
          showClose: true,
          message: _lang.default.t('message.organizationManagementMessage34') + e.message,
          type: 'warning'
        });
      });
    },
    handleResetPassword: function handleResetPassword(state) {
      var _this20 = this;

      if (this.checkSelection()) {
        return;
      }

      var message, info;

      if (state === 'resetPassword') {
        message = _lang.default.t('message.message35');
        info = _lang.default.t('SMS.alarm');
      }

      this.$confirm(message, info, {
        confirmButtonText: _lang.default.t('permission.confirm'),
        cancelButtonText: _lang.default.t('permission.cancel'),
        type: 'warning'
      }).then(function () {
        _this20.doResetPasswordData();
      }).catch(function () {
        _this20.$message({
          type: 'info',
          message: _lang.default.t('message.message36')
        });
      });
    },
    doResetPasswordData: function doResetPasswordData() {
      var _this21 = this;

      var accounts = '';

      for (var data in this.multipleSelection) {
        accounts = accounts === "" ? this.multipleSelection[data].userAccount.toString() : accounts.concat(',' + this.multipleSelection[data].userAccount.toString());
      }

      var _this = this;

      _httpUtils.default.post("organizationUser", "password/reset", null, accounts).then(function (res) {
        if (res.code === 200) {
          _this.$alert(_this.$t("message.message37") + _this.$t('message.message64') + " " + res.message + " " + _this.$t("system.user.userTable.resetSuccessInfo"), _this.$t("SMS.success"), {
            confirmButtonText: _this.$t("common.confirm")
          });

          _this21.listQuery.pageNum = _this21.listQuery.pageNum;
          _this21.listQuery.pageSize = 10;

          _this21.resetFormTemp();

          _this21.getList();
        }
      }).catch(function (e) {
        _this21.$message({
          showClose: true,
          message: _lang.default.t('message.message38') + e.message,
          type: 'warning'
        });
      });
    },
    checkSelection: function checkSelection() {
      var message, info;

      if (this.multipleSelection === undefined ? true : this.multipleSelection.length === 0) {
        message = _lang.default.t('message.message16');
        info = _lang.default.t('SMS.alarm');
        this.$message(message, info, {
          confirmButtonText: _lang.default.t('permission.confirm'),
          type: 'warning'
        });
        return true;
      }
    },
    handleTreeData: function handleTreeData(tree) {
      var head = [];

      if (tree.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = tree[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var data = _step2.value;
            var treeData = {
              id: data.id,
              label: data.title,
              children: []
            };
            head.push(treeData);

            if (data.childs.length > 0) {
              treeData.children = this.handleTreeData(data.childs);
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return head;
    },
    handleResetTree: function handleResetTree() {
      this.userLimit = [];
      this.dialogTreeVisible = false;
      this.resetPermissionTree();
    },
    doPermissionUpdate: function doPermissionUpdate() {
      var _this22 = this;

      var nodeKeys;

      if (this.$refs.tree.getCheckedKeys().length != 0) {
        nodeKeys = this.$refs.tree.getCheckedKeys().reduce(function (a, b) {
          if (a != null && b == null) {
            return a;
          }

          return a.concat("," + b);
        });
      } else {
        nodeKeys = "";
      }

      var data = null;

      if (this.batchUpdatePermissionFlag) {
        this.$confirm(_lang.default.t('warningMessage.batchUpdatePermissionConfirmMessage'), _lang.default.t('warningMessage.batchUpdatePermissionMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          var organizationUserIds = [];

          for (var item in _this22.multipleSelection) {
            organizationUserIds.push(_this22.multipleSelection[item].id);
          }

          if (nodeKeys.length == 0) {
            data = {
              menuIds: '',
              userIds: organizationUserIds
            };
          } else {
            data = {
              'eleTree-node': 'on',
              menuIds: nodeKeys,
              userIds: organizationUserIds
            };
          }

          _httpUtils.default.post("organizationUserLimit", "updatesByOrganizationUserIds", null, data).then(function (res) {
            if (res.code === 200) {
              _this22.$notify({
                title: _lang.default.t("SMS.success"),
                message: _lang.default.t("warningMessage.batchUpdatePermissionSuccessMessage"),
                type: "success",
                duration: 2000
              });

              _this22.handleResetTree();

              _this22.batchUpdatePermissionFlag = false;

              _this22.getList();
            }
          }).catch(function (e) {
            _this22.$notify({
              showClose: true,
              message: _lang.default.t("message.organizationManagementMessage44") + e.message,
              type: "warning"
            });
          });
        });
      } else {
        this.$confirm(_lang.default.t('warningMessage.updatePermissionConfirmMessage'), _lang.default.t('warningMessage.updatePermissionMessage'), {
          confirmButtonText: _lang.default.t('common.confirm'),
          cancelButtonText: _lang.default.t('common.cancel'),
          type: 'warning'
        }).then(function () {
          if (nodeKeys.length == 0) {
            data = {
              'menuIds': '',
              'userId': _this22.currentID
            };
          } else {
            data = {
              'eleTree-node': 'on',
              'menuIds': nodeKeys,
              userId: _this22.currentID
            };
          }

          _httpUtils.default.post("organizationUserLimit", "updates", null, data).then(function (res) {
            if (res.code === 200) {
              _this22.$notify({
                title: _lang.default.t('SMS.success'),
                message: _lang.default.t('warningMessage.updatePermissionSuccessMessage'),
                type: 'success',
                duration: 2000
              });

              _this22.dialogTreeVisible = false;
              _this22.currentID = null;

              _this22.getList();
            }
          }).catch(function (e) {
            _this22.$message({
              showClose: true,
              message: _lang.default.t('message.organizationManagementMessage44') + e.message,
              type: 'warning'
            });
          });
        });
      }
    },
    handleForceLogoff: function handleForceLogoff(id, userName) {
      var _this23 = this;

      this.$confirm(_lang.default.t('warningMessage.forceLogoffConfirmMessage'), _lang.default.t('warningMessage.forceLogoffMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this23.listLoading = true;

        _httpUtils.default.post("organizationUser", "forceLogoff", null, id).then(function (res) {
          var content = _lang.default.t('warningMessage.forceLogoffMessage') + " " + userName + " " + _lang.default.t('common.success');

          _this23.$message({
            message: content,
            type: 'success'
          });

          _this23.listLoading = false; //this.getList();
        });
      }).catch(function (error) {
        _this23.$message({
          message: error.message,
          type: 'error'
        });
      });
      setTimeout(function () {
        _this23.listLoading = false;
      }, 1 * 1000);
    },
    handleRemoveGoogle: function handleRemoveGoogle(id, userName) {
      var _this24 = this;

      this.$confirm(_lang.default.t('warningMessage.removeGoogleConfirmMessage'), _lang.default.t('warningMessage.removeGoogleMessage'), {
        confirmButtonText: _lang.default.t('common.confirm'),
        cancelButtonText: _lang.default.t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this24.listLoading = true;

        _httpUtils.default.post("organizationUser", "removeGoogle", null, id).then(function (res) {
          var content = _lang.default.t('warningMessage.removeGoogleMessage') + " " + userName + " " + _lang.default.t('common.success');

          _this24.$message({
            message: content,
            type: 'success'
          });

          _this24.listLoading = false; //this.getList();
        }).catch(function (error) {
          _this24.$message({
            message: error.message,
            type: 'error'
          });
        });
      });
      setTimeout(function () {
        _this24.listLoading = false;
      }, 1 * 1000);
    },
    handleQrcode: function handleQrcode(row) {
      this.resetQrcodeData();
      this.getQrcodeData(row);
      this.dialogType = "Qrcode";
      this.dialogQrcodeVisible = true;
    },
    resetQrcodeData: function resetQrcodeData() {
      this.qrcodeTemp = {
        googleQrcode: null,
        agentAccount: null
      };
    },
    getQrcodeData: function getQrcodeData(row) {
      var _this25 = this;

      _httpUtils.default.post("organizationUser", "getQrcode", null, row.id).then(function (res) {
        _this25.qrcodeTemp = res.data;

        if (res.data.googleQrcode != "null") {
          _this25.qrcode(res.data.googleQrcode);
        } else {
          document.getElementById("qrcode").innerHTML = _lang.default.t("SMS.unboundVerificationCode");
        }
      }).catch(function (err) {
        _this25.$notify({
          title: _this25.$t("common.error"),
          message: _this25.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    qrcode: function qrcode(link) {
      document.getElementById("qrcode").innerHTML = "";
      var that = this;
      var qrcode = new _qrcodejs.default("qrcode", {
        width: 250,
        height: 250,
        // 高度
        text: link // 二维码内容
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // backgrounds: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色

      });
    }
  }
};
exports.default = _default;